import { useParams, Navigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { useGetWebsiteSettingsQuery, useGetPublishedPageQuery } from "../../../app/websiteApiSlice";
import ModernPage from "./themes/modern/ModernPage";
import ClassicPage from "./themes/classic/ClassicPage";
import BoldPage from "./themes/bold/BoldPage";

export default function WebsitePageRenderer({ slug: slugProp } = {}) {
  const { slug: slugParam } = useParams();
  const slug = slugProp || slugParam;
  const { data: settings, isLoading: loadingSettings } = useGetWebsiteSettingsQuery();
  const { data: page, isLoading: loadingPage, isError } = useGetPublishedPageQuery(slug);

  if (loadingSettings || loadingPage) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !page) return <Navigate to="/404" replace />;

  const theme = settings?.theme || "modern";

  switch (theme) {
    case "classic":
      return <ClassicPage page={page} settings={settings} />;
    case "bold":
      return <BoldPage page={page} settings={settings} />;
    case "modern":
    default:
      return <ModernPage page={page} settings={settings} />;
  }
}
